import { createFileRoute, redirect } from '@tanstack/react-router';

// EPIC-06: rota consolidada em /sorteios?tab=historico. Mantida pra backward compat de bookmarks.
export const Route = createFileRoute('/_admin/sorteios/encerrados')({
  beforeLoad: () => {
    throw redirect({ to: '/sorteios', search: { tab: 'historico' }, replace: true });
  },
});
